import { Card, Divider, Typography } from "antd";
import AppLogo from "../../assets/img/logo.png";
import { Link } from "react-router-dom";

const { Title, Text } = Typography;

const AuthLayout = ({
    title,
    subtitle,
    children,
    actionText = "Don’t have an account?",
    actionLabel = "Sign Up",
    actionLink = "#",
    maxWidth,
}) => {
    return (
        <div className="auth-page">
            <div className="auth-overlay" />
            <Card className="auth-card" variant="borderless" hoverable={false} style={{ maxWidth }}>
                <div className="auth-header">
                    <img src={AppLogo} alt="Prefectos" className="auth-logo" />
                    <Title level={3} className="auth-title">
                        {title}
                    </Title>
                    {subtitle && <Text type="secondary">{subtitle}</Text>}
                </div>

                {children}

                <Divider plain>or</Divider>
                <div className="auth-actions">
                    <Text type="secondary">
                        {actionText}{" "}
                        <Link to={actionLink}>
                            {actionLabel}
                        </Link>
                    </Text>
                </div>
            </Card>
        </div>
    );
};

export default AuthLayout;
